import urlSubmissionError from './urlSubmissionError';

export default {
  redirect_url: urlSubmissionError,
  url: urlSubmissionError,
};
